import { selectPhoneNumberAllowedCountries } from 'redux-web/selectors/countries'

export const getAvailableCountryCodes = state =>
  selectPhoneNumberAllowedCountries(state).map(country => ({
    name: `${country.name} (+${country.callingCode})`,
    value: country.isoCode.toUpperCase(),
  }))
